// extracted by mini-css-extract-plugin
export default {"spinner":"RSa6IA","spin":"Fnp115"};